import { __ } from '@wordpress/i18n';

/**
 * Loads an image from the given source URL using a promise.
 *
 * @param {string} url The URL of the image to load.
 *
 * @return {Promise<HTMLImageElement>}     Resolves with the image element, or rejects with an error message.
 */
function loadImage(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();

    /**
     * Resolve the promise when the image is loaded.
     */
    image.onload = () => {
      resolve(image);
      image.onload = null;
      image.onerror = null;
    };

    /**
     * Reject the promise when the image fails to load.
     *
     * @param {*} error The error object.
     */
    image.onerror = (error) => {
      const message = error ? error.message : __('Unable to load image', 'mediapress');
      reject(new Error(message));
      image.onload = null;
      image.onerror = null;
    };

    image.decoding = 'async';
    image.src = url;
  });
}

export default loadImage;
